import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import Apropos from "@/pages/Apropos";
import Contact from "@/pages/Contact";
import MentionsLegales from "@/pages/MentionsLegales";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main data-testid="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<Apropos />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/:slug" element={<ServicePage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingActions />
      </BrowserRouter>
    </div>
  );
}

export default App;
